<template>
    <div class="service-wrap ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-payment-method"></i></span>
                                <h3><router-link to="/service-details">Easy Payment to Merchant</router-link></h3>
                            </div>
                            <p>
                                Netwallet ensures that your transactions (payment) with merchants are not only seamless but also secure.
                                With robust security measures in place, you can make payments to merchants confidently,
                                knowing that your financial information is protected. We prioritizes
                                the security and privacy of your transactions, giving you peace of mind as you engage in a variety of payment activities with merchants.
                            </p>
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-payment-method"></i></span>
                                <h3><router-link to="/service-details">Easy Mobile Recharge</router-link></h3>
                            </div>
                            <p>
                                Empower yourself with ViserPay's Mobile Recharge feature, designed to keep you seamlessly connected to your loved ones.
                                With just a few taps on your device, recharge your mobile balance quickly and effortlessly.
                                Choose your mobile operator, enter the necessary details, and recharge easily. Stay connected without the hassle,
                                ensuring you're always just a call or message away.
                            </p>
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-payment-method"></i></span>
                                <h3><router-link to="/service-details">Bill Payment</router-link></h3>
                            </div>
                            <p>💡 Tired of standing in queues? Pay your bills in seconds with [App Name] – fast, secure, and hassle-free!</p>
                            <p>⚡ Download now and experience seamless payments for electricity, water, gas, and more!</p>
                            <p>
                                🎉 New to Netwallet? Get ₹100 cashback on your first bill payment!
                                Just download, pay your bill, and save instantly. 💸
                            </p>
                            <!--<p>Effortlessly manage transactions (money-in and out) and craft your ideal transaction flow. Automate all your payments and transactions, reduce administrative works and save resources.</p>-->
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-payment-method"></i></span>
                                <h3><router-link to="/service-details">Add Money to your wallet</router-link></h3>
                            </div>
                            <p>Easily top up your wallet and enjoy faster, hassle-free payments anytime, anywhere.</p>
                            <p>With the Add Money feature, you can securely load funds into your wallet using your preferred payment methods 
                            — including Mobile Money, debit/credit cards, USSD, or net banking. Once added, use your wallet balance 
                            to make quick payments, purchases, or transfers without re-entering payment details each time.</p>

                            <!--<p>Add funds to your wallet with just a few taps, anytime, anywhere. 
                            Enjoy the flexibility of multiple payment methods: Mobile Money, Banks and Cards, choose what works best for you. 
                            Our secure and user-friendly interface makes it fast and easy. Stay prepared for any purchase: 
                            never get caught off guard with a low balance.</p>-->
                            <!--<p>We return powerful insights and real-time data enrichment for all fraud detection needs. Build trust throughout the user journey. Stop fake accounts, payment fraud</p>-->
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-computer"></i></span>
                                <h3><router-link to="/service-details">Cash Out: Convenient Withdrawals through Agent</router-link></h3>
                            </div>
                            <p>Netwallet CashOut feature allows you to withdraw cash conveniently through our extensive network of agent and partners. 
                            Simply locate the nearest agent, initiate the withdrawal process, and receive your funds securely. 
                            Enjoy the flexibility of accessing your money when needed, making Cash Out through agents a hassle-free 
                            and accessible option for all your cash withdrawal requirements.</p>
                            <!--<p>Automatically requests for updates to your Netwallet account information as the payment is being processed. Batch Account Updater.</p>-->
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-loan-1"></i></span>
                                <h3><router-link to="/service-details">Send Money: Instant and Secure Money Transfer</router-link></h3>
                            </div>
                            <p>Netwallet Send Money feature is your gateway to quick, secure, and hassle-free fund transfers. 
                            Whether you're sending money to friends, family, or associates, our platform ensures a seamless experience. 
                            With just a few taps, you can initiate transfers, providing you with the flexibility and convenience 
                            to send money whenever and wherever you need. Trust Netwallet to deliver your funds swiftly and securely.</p>
                            <!--<p>Transaction security is the most fundamental form of security checking that is required to secure any payment or any cash collection.</p>-->
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-secure-shield"></i></span>
                                <h3><router-link to="/service-details">Secure Payment</router-link></h3>
                            </div>
                            <p>Make payment in a safe, fast, and secure way to your recipient within Netwallet and to popular payment systems in Africa.</p>
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-mortarboard"></i></span>
                                <h3><router-link to="/service-details">Diapora and Families</router-link></h3>
                            </div>
                            <p>Connecting families​​ Mobile wallets allow people to send money to family, friends, and small businesses using mobile phones</p>
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6">
                    <div class="service-card style4">
                        <div class="service-info">
                            <div class="service-title">
                                <span><i class="flaticon-loan"></i></span>
                                <h3><router-link to="/service-details">Email Notification</router-link></h3>
                            </div>
                            <p>To keep you informed about the activity in your payments profile, Google sends email notifications for certain payments events.</p>
                            <!--<router-link to="/service-details" class="link style1">Learn More <i class="flaticon-right-arrow-1"></i></router-link>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-details-wrap ptb-100">
                <div class="container">
                    <div class="row gx-5">
                        <div class="col-xl-8 col-lg-12">
                            <div class="service-desc">
                                <lightgallery :settings="{ speed: 500, plugins: plugins }" :onInit="onInit" :onBeforeSlide="onBeforeSlide">
                                    <a v-for="item in items" :key="item.id" :data-lg-size="item.size" :data-src="item.src">
                                        <div class="service-img mb-25 d-block">
                                            <img className="img-responsive" :src="item.thumb" />
                                        </div>
                                    </a>
                                </lightgallery>
                                <h2>Mobile Banking</h2>
                                <p>
                                    As we acknowledge, in line with this technology and gadget
                                    development era today, most people have been familiar with any
                                    business and transaction online. Which means it has been a common
                                    thing for each person to at least have their own online banking
                                    to make it easier. In addition to that, we could also see how it is
                                    not just businesses that happened in a company, as most of the
                                    institutions and schools also offered an online payment for the fees.
                                </p>

                                <h2>How Digital Payment Works</h2>
                                <p>
                                    Digital payments are a fast, secure, and convenient way to transfer money without using cash.
                                    Whether you're paying for groceries, booking a ride, or buying something at a local shop,
                                    digital payments make transactions easier for both customers and businesses.
                                </p>
                                <ul class="content-feature-list style2 list-style">
                                    <li><i class="ri-check-line"></i>Customer Scans the QR Code or Enters Payment Info</li>
                                    <li><i class="ri-check-line"></i>Customer Enters the Amount & Confirms Payment</li>
                                    <li><i class="ri-check-line"></i>Payment is Processed Instantly</li>
                                    <li><i class="ri-check-line"></i>Merchant Receives Real-Time Confirmation</li>
                                    <li><i class="ri-check-line"></i>Money is Settled</li>
                                    <li><i class="ri-check-line"></i>24/7 Access to your Account Balance</li>
                                </ul>
                                <p>
                                    Online banking is fairly standard these days and a quick and easy way to access your money
                                    and manage your finances. It means you can do this on the go, from a computer, laptop,
                                    tablet, or mobile from anywhere in the world - rather than going into your bank when it is open.
                                    Discover everything you need to know about online banking.
                                </p>
                                <h2>More Asked Question</h2>
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                                    aria-expanded="true" aria-controls="collapseOne">
                                                <span>
                                                    <i class="ri-arrow-down-s-line plus"></i>
                                                    <i class="ri-arrow-up-s-line minus"></i>
                                                </span>
                                                What Is Wallet Account?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                             data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <div class="single-product-text">
                                                    <p>
                                                        A wallet account (also known as a digital wallet or e-wallet) is a type of financial account
                                                        that allows you to store money digitally and make payments using your smartphone or computer
                                                        without needing to carry cash or a physical card.
                                                    </p>
                                                    <ul class="content-feature-list style2 list-style">
                                                        <li><i class="ri-check-line"></i>Store Money Securely</li>
                                                        <li><i class="ri-check-line"></i>Make Quick Payments</li>
                                                        <li><i class="ri-check-line"></i>Send or Receive Money</li>
                                                        <li><i class="ri-check-line"></i>Link to Bank Account or UPI</li>
                                                        <li><i class="ri-check-line"></i>Track Transactions</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                <span>
                                                    <i class="ri-arrow-down-s-line plus"></i>
                                                    <i class="ri-arrow-up-s-line minus"></i>
                                                </span>
                                                How Do I Activate My Account?
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                             data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <p>
                                                    Activating your NetwalletPay account is quick and easy. Just follow these steps:
                                                </p>
                                                <ul class="content-feature-list style2 list-style">
                                                    <p>Step 1: Download the Netwallet Pay Application</p>
                                                    <p>Step 2: Register with Your Information</p>
                                                    <p>Step 3: Complete KYC (Know Your Customer)</p>
                                                    <p>Step 4: Start Accepting Payments!</p>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                                <span>
                                                    <i class="ri-arrow-down-s-line plus"></i>
                                                    <i class="ri-arrow-up-s-line minus"></i>
                                                </span>
                                                How Do I Change My Password?
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                             data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <p>
                                                    Ensure that your register number and email are active. Select 'forgot password',
                                                    follow the instruction to reset the password through SMS or email.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-12">
                            <div class="sidebar">
                                <div class="sidebar-widget style2">
                                    <h4>All Services</h4>
                                    <div class="category-box style2">
                                        <ul class="list-style">
                                            <li>
                                                <router-link to="/service-details">
                                                    Mobile Banking
                                                    <span><i class="flaticon-next"></i></span>
                                                </router-link>
                                            </li>
                                            <!--<li>
                                              <router-link to="/service-details">
                                                Personal Loans
                                                <span><i class="flaticon-next"></i></span>
                                              </router-link>
                                            </li>-->
                                            <li>
                                                <router-link to="/service-details">
                                                    Merchant Banking
                                                    <span><i class="flaticon-next"></i></span>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link to="/service-details">
                                                    Credit Cards
                                                    <span><i class="flaticon-next"></i></span>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link to="/service-details">
                                                    Online Payment
                                                    <span><i class="flaticon-next"></i></span>
                                                </router-link>
                                            </li>
                                            <!--<li>
                                              <router-link to="/service-details">
                                                Corporate Banking
                                                <span><i class="flaticon-next"></i></span>
                                              </router-link>
                                            </li>-->
                                        </ul>
                                    </div>
                                </div>
                                <div class="sidebar-widget style2">
                                    <h4>Business Hours</h4>
                                    <div class="schedule-widget">
                                        <ul class="list-style">
                                            <li>
                                                <h6>Mon-Thurs</h6>
                                                <p>8:00 AM - 6:00 PM</p>
                                            </li>
                                            <li>
                                                <h6>Fri-Sat</h6>
                                                <p>8:00 AM - 3:00 PM</p>
                                            </li>
                                            <li>
                                                <h6>Sun</h6>
                                                <p>Closed</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="sidebar-widget style3">
                                    <div class="contact-widget-form">
                                        <div class="overlay op-95 bg-rock"></div>
                                        <h4>Lets Talk</h4>
                                        <div v-if="msg">
                                            <p class="text-success">{{ msg }}</p>
                                        </div>
                                        <form @submit.prevent="sendContactRequest">
                                            <div class="form-group">
                                                <input type="text" placeholder="Name" />
                                            </div>
                                            <div class="form-group">
                                                <input type="email" placeholder="Email" />
                                            </div>
                                            <div class="form-group">
                                                <input type="phone" placeholder="Phone" />
                                            </div>
                                            <div class="form-group">
                                                <textarea name="msg" id="msg" cols="30" rows="10" placeholder="Message"></textarea>
                                            </div>
                                            <button class="btn style1 d-block w-100" type="submit">
                                                Send Message
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!--<ul class="page-nav list-style mt-20">
                <li><a href="/services-two"><i class="flaticon-back"></i></a></li>
                <li><a class="active" href="/services-two">1</a></li>
                <li><a href="/services-two">2</a></li>
                <li><a href="/services-two">3</a></li>
                <li><a href="/services-two"><i class="flaticon-next-1"></i></a></li>
            </ul>-->
        </div>
    </div>

</template>

<script>
    import Lightgallery from "lightgallery/vue";
    import lgZoom from "lightgallery/plugins/zoom";
    let lightGallery = null;

    export default {
        name: "ServicesDetails",
        components: {
            Lightgallery,
        },
        watch: {
            items() {
                this.$nextTick(() => {
                    lightGallery.refresh();
                });
            },
        },
        data: () => ({
            plugins: [lgZoom],
            items: [
                {
                    id: "1",
                    src: require("../../assets/images/service/single-service-2.jpg"),
                    thumb: require("../../assets/images/service/single-service-2.jpg"),
                },
            ],
            msg: ""
        }),
        methods: {
            onInit: (detail) => {
                lightGallery = detail.instance;
            },
            onBeforeSlide: () => {
                console.log("calling before slide");
            },
            async sendContactRequest() {
                try {
                    const response = await axios.post('/api/v1/contact/receive-message', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        subject: this.msg_subject,
                        message: this.message,
                    });
                    this.msg = "We have received your message. Thanks for you contribution.";
                } catch (error) {
                    console.error(error);
                    const { message } = error.response.data;

                    // Handle the login error
                    this.msg = message || 'Unexpected error, please try again later';
                }
            },
        },
        name: 'Services'
    }
</script>
<style lang="css">
    @import url("https://cdn.jsdelivr.net/npm/lightgallery@2.1.0-beta.1/css/lightgallery.css");
    @import url("https://cdn.jsdelivr.net/npm/lightgallery@2.1.0-beta.1/css/lg-zoom.css");
</style>
